import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=05c5bbd7&scoped=true&"
import script from "./Fashion.vue?vue&type=script&lang=js&"
export * from "./Fashion.vue?vue&type=script&lang=js&"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=05c5bbd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5bbd7",
  null
  
)

export default component.exports